import {
  Modal as ChakraModal,
  ModalBody,
  ModalBodyProps,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps as ChakraModalProps,
} from "@chakra-ui/react";
import React from "react";

import { Button } from "../../../components";

export interface ModalProps {
  completeButtonText: string;
  headerText: string;
  isOpen: boolean;
  isLoading?: boolean;
  isDestructive?: boolean;
  hasHeaderBorder?: boolean;
  children: React.ReactNode;
  onClose: () => void;
  onComplete: () => void;
  cancelButtonText?: string;
  completeButtonDisabled?: boolean;
  bodyProps?: ModalBodyProps;
  modalProps?: Omit<ChakraModalProps, "isOpen" | "onClose" | "children">;
}

const Modal: React.FC<ModalProps> = ({
  children,
  headerText,
  completeButtonText,
  isOpen,
  isLoading,
  isDestructive,
  onClose,
  onComplete,
  cancelButtonText = "Cancel",
  completeButtonDisabled = false,
  hasHeaderBorder = false,
  bodyProps,
  modalProps,
}) => (
  <ChakraModal
    isOpen={isOpen}
    closeOnOverlayClick={false}
    onClose={onClose}
    {...modalProps}
  >
    <ModalOverlay>
      <ModalContent borderRadius="24px">
        <ModalHeader
          color="gray.900"
          fontWeight="600"
          fontSize="2xl"
          lineHeight="8"
          // maxWidth="90%"
          pl="6"
          pr="72px"
          pt="6"
          pb="4"
          borderBottom={hasHeaderBorder ? "1px" : "0"}
          borderBottomColor="gray.100"
        >
          {headerText}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="10" pt="8" pb="14" {...bodyProps}>
          {children}
        </ModalBody>
        <ModalFooter
          borderTop="1px"
          borderTopColor="gray.100"
          justifyContent="space-between"
          px={6}
        >
          <Button variant="ghost" fontWeight="500" onClick={onClose}>
            {cancelButtonText}
          </Button>
          <Button
            fontWeight="500"
            textTransform="unset"
            variant={isDestructive ? "danger" : undefined}
            borderRadius="8px"
            isLoading={isLoading}
            isDisabled={completeButtonDisabled}
            _hover={{
              bg: isDestructive ? "red.500" : "blue.500",
              _disabled: {
                bg: "gray.100",
              },
            }}
            onClick={() => {
              onComplete();
              onClose();
            }}
          >
            {completeButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  </ChakraModal>
);

export default Modal;
